/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Unscheduled/view.blocks to change it.
import DiagnosisAction from './DiagnosisAction/index'
import More from './More/index'
import React from 'react'
import Schedule from './Schedule/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Unscheduled({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Unscheduled.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Schedule
  viewPath={`${viewPath}/Schedule`}
/>
<DiagnosisAction
  viewPath={`${viewPath}/DiagnosisAction`}
/>
</div>
<More
  viewPath={`${viewPath}/More`}
/>
{children}
</React.Fragment>)
}